import { useAui, useAuiState } from "@assistant-ui/react";
import type { RefObject } from "react";
import { useCopilotPageContext } from "@/features/copilot/components/copilot-page-context-provider";
import { applyCopilotStarter } from "@/features/copilot/lib/copilot-starter";
import { Button } from "@/shared/components/ui/button";

export function CopilotStarters({
  composerRef,
}: {
  composerRef: RefObject<HTMLTextAreaElement | null>;
}) {
  const aui = useAui();
  const threadIsEmpty = useAuiState((state) => state.thread.isEmpty);
  const { context, dismissed } = useCopilotPageContext();
  if (!threadIsEmpty || !context || dismissed) return null;

  return (
    <ul aria-label="Suggested questions" className="mb-2 flex flex-wrap gap-1.5">
      {context.starters.map((starter) => (
        <li key={starter}>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-auto whitespace-normal py-1 text-left text-xs"
            onClick={() =>
              applyCopilotStarter(
                {
                  setText: (text) => aui.composer().setText(text),
                  focus: () => composerRef.current?.focus(),
                },
                starter,
              )
            }
          >
            {starter}
          </Button>
        </li>
      ))}
    </ul>
  );
}
